angular.module('unergie.main')
.controller('promosCtrl', ($scope, $state, $uibModal, AccountService, AlertManager, DataAccessRefPromo, TableGeneratorService, ModalService,
    ReferencesService, DataAccessOffers, ErrorCatcher) => {
    $scope.booleanFilter = [{ id: 'true', title: 'Oui' }, { id: 'false', title: 'Non' }]
    $scope.zeroOneFilter = [{ id: '1', title: 'Oui' }, { id: '0', title: 'Non' }]
    $scope.retributionTypeFilter = [{ id: 'pot', title: 'Cagnotte' }, { id: 'offer', title: 'Offre' }, { id: 'annual-pot', title: 'Cagnotte annuelle' }]
    $scope.categoriesSelectFilter = []
    $scope.categoriesFilter = {}

    $scope.promos = {
        show: {},
        refreshing: false,
        columns: {
            'id': { label: 'Id', mode: 'search_wildcard', mandatory: true },
            'status': { label: 'Actif', mode: 'search_strict' },
            'ref_category': { label: 'Catégorie', mode: 'search_strict' },
            'sub_category': { label: 'Sous catégorie', mode: 'search_wildcard' },
            'start_date': { label: 'Date début', mode: 'search_date' },
            'end_date': { label: 'Date fin', mode: 'search_date' },
            'email_pattern': { label: 'Email', mode: 'search_wildcard' },
            'postcode_pattern': { label: 'Code postal', mode: 'search_wildcard' },
            'limit_number': { label: 'Limite', mode: 'search_operator' },
            'limit_for_user': { label: 'Limite par compte', mode: 'search_operator' },
            'meter_kinds': { label: 'Type compteur', mode: 'search_wildcard' },
            'contract_identifier': { label: 'Numéro contrat', mode: 'search_wildcard' },
            'manual_check': { label: 'Validation manuelle', mode: 'search_strict', isVisible: false },
            'retribution_type': { label: 'Type', mode: 'search_strict' },
            'offer_id': { label: 'Offre', mode: 'search_wildcard' },
            'retribution_amount': { label: 'Montant', mode: 'search_operator' },
            'ambassador_customer_id': { label: 'Ambassadeur', mode: 'search_wildcard' },
            'ambassador_retribution_amount': { label: 'Montant ambassadeur', mode: 'search_operator' },
            'ambassador.fullname': { label: 'Nom ambassadeur', mode: 'search_wildcard' },
            'label_fr': { label: 'Phrase de validation', mode: 'hidden' },
            'custom_checks': { label: 'Checks supp.', mode: 'hidden' },
        },
    }

    $scope.refresh = () => TableGeneratorService.getTable($scope.promos, 'ref-promo')
    $scope.refresh()

    let offers = []

    $scope.update = () => DataAccessRefPromo.putPromo({ id: $scope.promoEditTemplate.id }, _.pick($scope.promoEditTemplate, Object.keys($scope.updatePromoFields))).$promise
    .then((data) => {
        AlertManager.success('Promo mise à jour')
        $scope.refresh()
    }).catch(ErrorCatcher)

    $scope.isActive = (state) => $state.is(state)

    $scope.delete = (promo) =>
        DataAccessRefPromo.delPromo({ id: promo.id }).$promise.then((data) => $scope.refresh()).catch(ErrorCatcher)


    const promoTemplate = {
        id: '',
        status: 1,
        start_date: undefined,
        end_date: undefined,
        email_pattern: '',
        postcode_pattern: '',
        limit_number: undefined,
        limit_for_user: undefined,
        meter_kinds: '',
        contract_identifier: '',
        manual_check: false,
        retribution_type: 'pot',
        retribution_amount: 0,
        offer_id: '',
        label_fr: '',
    }
    $scope.promoFields = {
        id: {
            label: 'ID',
            required: true,
            type: 'text',
        },
        status: {
            label: 'Actif',
            type: 'select',
            enum: [{ value: 1, label: 'Oui' }, { value: 0, label: 'Non' }],
        },
        ref_category: {
            label: 'Catégorie',
            type: 'select',
            required: true,
            enum: [],
        },
        sub_category: {
            label: 'Sous catégorie',
            type: 'text',
        },
        start_date: {
            label: 'Date de début',
            type: 'date',
        },
        end_date: {
            label: 'Date de fin',
            type: 'date',
        },
        email_pattern: {
            label: 'Pattern de mail',
            type: 'text',
        },
        postcode_pattern: {
            label: 'Pattern de code postal',
            type: 'text',
        },
        limit_number: {
            label: 'Limite totale',
            type: 'text',
        },
        limit_for_user: {
            label: 'Limite par client',
            type: 'text',
        },
        meter_kinds: {
            label: 'Types de compteurs',
            type: 'text',
        },
        contract_identifier: {
            label: 'Type de contrat',
            type: 'select',
            enum: [
                { value: 'first', label: 'Premier' },
                { value: 'next', label: 'Suivants' },
                { value: 'second', label: 'Deuxième' },
                { value: 'third', label: 'Troisième' },
            ],
        },
        manual_check: {
            label: 'Validation interne',
            type: 'select',
            enum: [{ value: true, label: 'Oui' }, { value: false, label: 'Non' }],
        },
        retribution_type: {
            label: 'Type',
            type: 'radio',
            required: true,
            enum: [{ value: 'pot', label: 'Cagnotte' }, { value: 'offer', label: 'Offre' }, { value: 'annual-pot', label: 'Cagnotte annuelle' }],
        },
        retribution_amount: {
            hidden: (t) => t.retribution_type === 'offer',
            label: (t) => (t.retribution_type === 'pot' ? 'Montant cagnotte (€)' : 'Montant cagnotte (€ / année complète)'),
            type: 'number',
        },
        offer_id: {
            hidden: (t) => ['pot', 'annual-pot'].includes(t.retribution_type),
            label: 'Id Offre',
            type: 'select',
            enum: [],
        },
        label_fr: {
            label: 'Phrase de validation',
            type: 'text',
        },
        ambassador_customer_id: {
            label: 'Ambassadeur (customer_id)',
            type: 'text',
        },
        ambassador_retribution_amount: {
            hidden: (t) => !t.ambassador_customer_id,
            label: 'Montant ambassadeur',
            type: 'text',
        },
        custom_checks: {
            label: (t) => (t.retribution_type === 'annual-pot' ? 'Checks supp. (déclarez maxAnnualPotDurationDays(jours))' : 'Checks supplémentaires'),
            type: 'json',
            required: (t) => t.retribution_type === 'annual-pot',
        },
    }

    $scope.updatePromoEditTemplate = (promo) => {
        $scope.promoEditTemplate = _.cloneDeep(promo || promoTemplate)
    }
    $scope.updatePromoEditTemplate()

    DataAccessOffers.getOffers().$promise.then((data) => {
        offers = _.map(data, (elem) => ({ value: elem.id, label: elem.id }))
        $scope.promoFields.offer_id.enum = offers
        $scope.updatePromoFields.offer_id.enum = offers
    }).catch(ErrorCatcher)

    $scope.refreshPromoCategories = () =>
        DataAccessRefPromo.getPromoCategories().$promise.then((data) => {
            $scope.categories = _.map(data, (elem) => ({ value: elem.id, label: elem.name }))
            _.remove($scope.categoriesSelectFilter, (elem) => elem.id)
            $scope.categoriesFilter = []
            _.each(data, (d) => {
                $scope.categoriesSelectFilter.push({ id: `${d.id}`, title: d.name })
                $scope.categoriesFilter[d.id] = d.name
            })
            $scope.promoFields.ref_category.enum = $scope.categories
            $scope.updatePromoFields.ref_category.enum = $scope.categories
        }).catch(ErrorCatcher)

    $scope.refreshPromoCategories()

    $scope.updatePromoFields = angular.copy($scope.promoFields)
    $scope.updatePromoFields.id.hidden = true

    const resetPromoPayload = () => {
        $scope.promoPayload = angular.copy(promoTemplate)
    }

    resetPromoPayload()

    $scope.new = () =>
        DataAccessRefPromo.postPromo($scope.promoPayload).$promise.then((data) => {
            AlertManager.success('Promo ajoutée')
            $scope.refresh()
            resetPromoPayload()
        }).catch(ErrorCatcher)

    $scope.openCategoriesModal = () => ModalService.openModal({ type: 'promoCategoriesModal', size: 'lg' }, {}, $scope.refreshPromoCategories)
})
